<template>
  <div v-if="timers.length" class="timer-bar">
    <div
      v-for="timer in timers"
      :key="timer.id"
      class="timer"
      :class="{ 'timer--done': remainingFor(timer) === 0 }"
      role="status"
    >
      <span class="timer__label">{{ timer.label }}</span>
      <span class="timer__time">{{ remainingFor(timer) === 0 ? 'Done' : formatSeconds(remainingFor(timer)) }}</span>
      <span class="timer__actions">
        <button type="button" class="timer__btn" title="Add a minute" @click="$emit('extend', timer.id, 60)">+1m</button>
        <button type="button" class="timer__btn" title="Dismiss" @click="$emit('dismiss', timer.id)">✕</button>
      </span>
    </div>
  </div>
</template>

<script>
// Every running timer, pinned to the bottom of cook mode so it is visible
// from whichever step the screen is on. Ticks once a second off the wall
// clock; the parent owns the list and the alarm.
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { remaining, formatSeconds } from '../utils/timers.js';

export default {
  name: 'TimerBar',
  props: { timers: { type: Array, default: () => [] } },
  emits: ['extend', 'dismiss'],
  setup () {
    const now = ref(Date.now());
    let tick = null;
    onMounted(() => { tick = setInterval(() => { now.value = Date.now(); }, 500); });
    onBeforeUnmount(() => clearInterval(tick));
    const remainingFor = (timer) => remaining(timer, now.value);
    return { remainingFor, formatSeconds };
  }
};
</script>

<style scoped>
.timer-bar { position: fixed; left: 0; right: 0; bottom: 0; z-index: 60; display: flex; flex-direction: column; gap: 0.35rem; padding: 0.5rem 0.75rem calc(var(--safe-bottom) + 0.5rem) 4rem; background: linear-gradient(to top, var(--bg) 70%, transparent); pointer-events: none; }
.timer { pointer-events: auto; display: flex; align-items: center; gap: 0.75rem; background: var(--text); color: #fff; border-radius: 999px; padding: 0.45rem 0.6rem 0.45rem 1rem; box-shadow: 0 4px 16px rgba(0,0,0,0.25); max-width: 44rem; margin: 0 auto; width: 100%; }
.timer--done { background: var(--accent); animation: pulse 1s infinite alternate; }
@keyframes pulse { from { transform: scale(1); } to { transform: scale(1.02); } }
.timer__label { flex: 1; font-weight: 600; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.timer__time { font-variant-numeric: tabular-nums; font-size: 1.35rem; font-weight: 800; }
.timer__actions { display: flex; gap: 0.3rem; }
.timer__btn { border: 0; background: rgba(255,255,255,0.18); color: #fff; border-radius: 999px; min-width: 40px; min-height: 36px; padding: 0 0.6rem; font-weight: 700; }
.timer__btn:active { background: rgba(255,255,255,0.35); }
</style>
